
































































































































































































































































































































































import { Vue, Component, Prop } from "vue-property-decorator";
import { DocPercorsoFormativo } from "../../_models/docPercorsoFormativo";
import { bus } from "../../main";
import * as user from "../../_store/user.module";

@Component
export default class PercorsoFormativoAlternanzaSign extends Vue {
  @Prop() docInfo!: DocPercorsoFormativo;
  @Prop() soggetto!: string;
  private firmaAzienda: string;

  constructor() {
    super();
    this.firmaAzienda = "";
  }

  clearEnterpriseSignature() {
    //@ts-ignore
    this.$refs.enterpriseSignaturePad.clearSignature();
  }

  clearStudentSignature() {
    //@ts-ignore
    this.$refs.studentSignaturePad.clearSignature();
  }
  clearEnterpriseDueSignature() {
    //@ts-ignore
    this.$refs.enterpriseSignatureDuePad.clearSignature();
  }

  clearStudentDueSignature() {
    //@ts-ignore
    this.$refs.studentSignatureDuePad.clearSignature();
  }

  clearTutoreSignature() {
    //@ts-ignore
    this.$refs.enterpriseSignatureDuePad.clearSignature();
  }

  close() {
    bus.$emit("closeDocSignDialog");
  }

  save() {
    if (this.soggetto === "azienda" || this.soggetto === "tutorAziendale") {
      //@ts-ignore
      const signatureAzienda = this.$refs.enterpriseSignaturePad.saveSignature();
      //@ts-ignore
      const signatureAziendaDue = this.$refs.enterpriseSignaturePad.saveSignature(); //this.$refs.enterpriseSignatureDuePad.saveSignature();

      if (
        signatureAzienda.isEmpty === false &&
        signatureAziendaDue.isEmpty === false
      ) {
        const payload = {
          idPercorsoFormativo: this.docInfo.idPercorsoFormativo,
          firma: signatureAzienda.data,
          firmaDue: signatureAziendaDue.data,
          firmaTutore: "",
          soggetto: this.soggetto
        };
        user
          .dispatchSignPercorsoFormativo(this["$store"], payload)
          .then(() => {
            bus.$emit(
              "successfullOperation",
              "Percorso Formativo Firmato con successo"
            );
            bus.$emit("loadPercorsoFormativo");
            this.close();
          })
          .catch(error => {
            if (error.response.status === 403) {
              bus.$emit("errorOperation", error.response.statusText);
              this["$router"].push("/login");
            } else {
              bus.$emit("errorOperation", error.response.statusText);
            }
          });
      } else {
        bus.$emit("errorOperation", "Firma Legale Rappresentante mancante");
      }
    } else if(this.soggetto === "istituto"){
      //@ts-ignore
      const signatureTutorArticolazione = this.$refs.enterpriseSignaturePad.saveSignature();

      if ( signatureTutorArticolazione.isEmpty === false ) {
        const payload = {
          idPercorsoFormativo: this.docInfo.idPercorsoFormativo,
          firma: signatureTutorArticolazione.data,
          firmaDue: "",
          firmaTutore: "",
          soggetto: this.soggetto
        };
        user
          .dispatchSignPercorsoFormativo(this["$store"], payload)
          .then(() => {
            bus.$emit(
              "successfullOperation",
              "Percorso Formativo Firmato con successo"
            );
            bus.$emit("loadPercorsoFormativo");
            this.close();
          })
          .catch(error => {
            if (error.response.status === 403) {
              bus.$emit("errorOperation", error.response.statusText);
              this["$router"].push("/login");
            } else {
              bus.$emit("errorOperation", error.response.statusText);
            }
          });
      } else {
        bus.$emit("errorOperation", "Una o più firme mancanti");
      }
    } 
    else {
      //@ts-ignore
      //const signatureAllievo = this.$refs.studentSignaturePad.saveSignature();
      //@ts-ignore
      const signatureAllievoDue = this.$refs.studentSignatureDuePad.saveSignature();
      //@ts-ignore
      //const signatureTutore = this.$refs.tutoreSignaturePad.saveSignature();
      if (
        signatureAllievoDue.isEmpty === false
      ) {
        const payload = {
          idPercorsoFormativo: this.docInfo.idPercorsoFormativo,
          firma: signatureAllievoDue.data,
          firmaDue: signatureAllievoDue.data,
          firmaTutore: "",
          soggetto: this.soggetto
        };
        user
          .dispatchSignPercorsoFormativo(this["$store"], payload)
          .then(() => {
            bus.$emit(
              "successfullOperation",
              "Percorso Formativo Firmato con successo"
            );
            bus.$emit("loadPercorsoFormativo");
            this.close();
          })
          .catch(error => {
            if (error.response.status === 403) {
              bus.$emit("errorOperation", error.response.statusText);
              this["$router"].push("/login");
            } else {
              bus.$emit("errorOperation", error.response.statusText);
            }
          });
      } else {
        bus.$emit("errorOperation", "Una o più firme mancanti");
      }
    }
  }
}
